package org.multiplatform.kotfolio.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.compositionLocalOf
import org.multiplatform.kotfolio.models.Theme
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.multiplatform.kotfolio.rememberAppState

val LocalBreakpoint = compositionLocalOf { Breakpoint.ZERO }

@Composable
@Layout
fun PageLayout(content: @Composable ColumnScope.() -> Unit) {
    val breakpoint = rememberAppState().breakpoint

    LaunchedEffect(Unit) {
        updatePageProperties {
            title = title
            description = description
        }
    }

    CompositionLocalProvider(LocalBreakpoint provides breakpoint) {
        Box(modifier = Modifier.fillMaxSize().backgroundColor(Theme.Background.rgb)) {
            // Page content
            Column(
                modifier = Modifier.fillMaxSize(),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.Start,
            ) {
                content()
            }
        }
    }
}